import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import ERROR_TO_PRINT from '@/errorManagement/errorMapping';
import Stopper from '@/errorManagement/errorPages/default';
import { DEFAULT_ERROR_PAGE_TEXT } from '@/errorManagement/errorPages/constants';
import { actions as modalActions } from '@/bit/reducers/reducers.modals-reducer';

function Core({ children, ...props }) {
  const dispatch = useDispatch();
  const { modalHistory } = useSelector((state) => state.modals);
  const {
    handlingCode,
    errorToPrint,
    buttonText = DEFAULT_ERROR_PAGE_TEXT.BUTTON_TEXT,
    buttonHref = DEFAULT_ERROR_PAGE_TEXT.BUTTON_HREF,
    homeUrl,
  } = useSelector((state) => state.error);

  useEffect(() => {
    // cerramos modal si ko en api es fatal y hay modal abierto
    if (modalHistory.length > 0 && handlingCode < 0) {
      dispatch(modalActions.addModal({ type: '', id: '' }));
    }
  }, [modalHistory.length, handlingCode]);

  return (
    <>
      {handlingCode < 0 &&
        (ERROR_TO_PRINT[errorToPrint] ? (
          ERROR_TO_PRINT[errorToPrint]({
            ...props,
            buttonHref,
            buttonText,
            linkUrl: homeUrl,
          })
        ) : (
          <Stopper {...props} buttonHref={buttonHref} buttonText={buttonText} />
        ))}
      {handlingCode >= 0 && children}
    </>
  );
}

Core.propTypes = {
  children: PropTypes.node.isRequired,
};
export default Core;
